import Blue from "~/core";
import Swiper, { Navigation, Autoplay } from 'swiper';

new Blue({
	name: 'Registration Box Swiper',
	selector: ".registration-box__swiper",
	setup(registration) {
        Swiper.use([Navigation]);
        Swiper.use([Autoplay]);
        const swiper = new Swiper(registration, {
            direction: 'horizontal',
            loop: true,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
          });
	}
});

new Blue({
	name: 'Sponsors Swiper',
	selector: ".registration-box__sponsor",
	setup(sponsors) {
        Swiper.use([Autoplay]);
        const swiper = new Swiper(sponsors, {
            direction: 'horizontal',
            loop: true,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
          });
	}
});